import { Link, NavLink } from "react-router-dom";
import { ShoppingBasket, Menu, Sprout } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "./ui/sheet";
import { useCart } from "../context/CartContext";
import { CartDrawer } from "./CartDrawer";

const NAV = [
  { to: "/", label: "The Farm" },
  { to: "/shop", label: "The Harvest" },
  { to: "/seasons", label: "Seasons" },
  { to: "/gallery", label: "Gallery" },
  { to: "/tours", label: "Farm Tours" },
  { to: "/garden-sage", label: "Garden Sage" },
];

export const Header = () => {
  const { count, popKey, setIsOpen } = useCart();

  return (
    <header className="fixed top-0 inset-x-0 z-40 backdrop-blur-xl bg-[#0A0A0A]/60 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 h-20 grid grid-cols-[1fr_auto_1fr] items-center">
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:text-saffron ${
                  isActive ? "text-saffron" : "text-zinc-400"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <Sheet>
          <SheetTrigger asChild>
            <button
              data-testid="mobile-menu-trigger"
              className="md:hidden text-zinc-300 hover:text-saffron transition-colors focus-ring"
              aria-label="Open menu"
            >
              <Menu className="w-6 h-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="bg-surface border-line">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <div className="flex flex-col gap-8 mt-16">
              {NAV.map((n) => (
                <Link
                  key={n.to}
                  to={n.to}
                  data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="font-display text-3xl text-zinc-200 hover:text-saffron transition-colors"
                >
                  {n.label}
                </Link>
              ))}
            </div>
          </SheetContent>
        </Sheet>

        <Link
          to="/"
          data-testid="brand-logotype"
          className="flex items-center justify-center gap-2 group"
        >
          <Sprout className="w-5 h-5 text-saffron transition-transform duration-500 group-hover:rotate-12" />
          <span className="font-display text-2xl sm:text-3xl tracking-tight text-zinc-100">
            The Garlic <span className="italic text-saffron">Hog</span>
          </span>
        </Link>

        <div className="flex justify-end">
          <button
            data-testid="cart-drawer-trigger"
            onClick={() => setIsOpen(true)}
            className="relative flex items-center gap-2 border border-line rounded-full px-5 py-2.5 text-xs uppercase tracking-[0.2em] text-zinc-300 hover:border-saffron hover:text-saffron transition-colors duration-300 focus-ring"
          >
            <ShoppingBasket className="w-4 h-4" />
            <span className="hidden sm:inline">Basket</span>
            {count > 0 && (
              <span
                key={popKey}
                data-testid="cart-count-badge"
                className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-saffron text-obsidian text-xs font-bold flex items-center justify-center animate-cart-pop"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
      <CartDrawer />
    </header>
  );
};
